import Sortable from "sortablejs";

function getTableBody(vm, tableRef) {
  const table = vm.$refs[tableRef];
  if (!table || !table.$el) {
    return null;
  }
  return table.$el.querySelector(".el-table__body-wrapper tbody");
}

function getList(vm, listKey) {
  const list = vm[listKey];
  return Array.isArray(list) ? list : [];
}

export function createTableDragSort(vm, options) {
  let sortable = null;
  const { tableRef, listKey, onSorted } = options;

  const destroy = () => {
    if (sortable) {
      sortable.destroy();
      sortable = null;
    }
  };

  const init = () => {
    vm.$nextTick(() => {
      destroy();
      const tbody = getTableBody(vm, tableRef);
      if (!tbody) {
        return;
      }

      sortable = Sortable.create(tbody, {
        animation: 150,
        handle: ".drag-handle",
        ghostClass: "drag-ghost",
        chosenClass: "drag-chosen",
        onEnd(evt) {
          if (evt.oldIndex === evt.newIndex || evt.oldIndex == null || evt.newIndex == null) {
            return;
          }

          const list = getList(vm, listKey);
          if (!list.length) {
            return;
          }

          const oldList = list.map((item) => ({ ...item }));
          const currentList = list.map((item) => ({ ...item }));
          const movedItem = currentList.splice(evt.oldIndex, 1)[0];
          currentList.splice(evt.newIndex, 0, movedItem);
          const maxExistingSort = oldList.reduce((max, item) => {
            const sort = Number(item.sort) || 0;
            return sort > max ? sort : max;
          }, 0);
          const maxSort = Math.max(maxExistingSort, currentList.length);
          currentList.forEach((item, index) => {
            // 后端列表统一按 sort DESC 查询，顶部项需要更大的 sort 值。
            item.sort = maxSort - index;
          });

          if (typeof onSorted === "function") {
            onSorted.call(vm, {
              list: currentList,
              oldList,
              oldIndex: evt.oldIndex,
              newIndex: evt.newIndex,
            });
          }
        },
      });
    });
  };

  return {
    init,
    destroy,
  };
}

function hasSortChanged(item, oldList) {
  if (!Array.isArray(oldList) || !oldList.length) {
    return true;
  }
  const oldItem = oldList.find((old) => old.id === item.id);
  if (!oldItem) {
    return true;
  }
  return Number(oldItem.sort) !== Number(item.sort);
}

export async function updateSortSequentially(list, saveItem, oldList) {
  for (let index = 0; index < list.length; index += 1) {
    const item = list[index];
    if (!hasSortChanged(item, oldList)) {
      continue;
    }
    const response = await saveItem(item, index);
    if (!response || response.code != 200) {
      return response;
    }
  }
  return { code: 200 };
}



// WEBPACK FOOTER //
// ./src/utils/tableDragSort.js